import { render, staticRenderFns } from "./Tintometrico.vue?vue&type=template&id=46223d20"
import script from "./Tintometrico.vue?vue&type=script&lang=js"
export * from "./Tintometrico.vue?vue&type=script&lang=js"
import style0 from "./tintometrico.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports